import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic";
import styles from "./animeSeriesCard.module.scss";
import RouterLink from "../link/RouterLink";

function AnimeSeriesCard({ series }) {
  return (
    <div className={styles.root}>
      <RouterLink className={styles.imageLink} href={series.series_url}>
        {series.imageSrc
          ? <img src={series.imageSrc} alt={series.crcms_title} />
          : (
            <StoryblokImageBasic
              withClass={styles.image}
              image={
                series.crcms_tall_poster && series.crcms_tall_poster.filename
                  ? series.crcms_tall_poster
                  : null
              }
              width={172}
              height={262}
            />
          )}
      </RouterLink>
      <RouterLink href={series.series_url} className={styles.link}>
        <p className={styles.title}>{series.crcms_title}</p>
      </RouterLink>
    </div>
  );
}

export default AnimeSeriesCard;
